<template>
  <div class="box6">
    <div class="box6-btm-box" id="box6-btm-box">
      <pageTitle
        title="4大阶段 6大热门行业赋能教学效果<br/>
      为大模型应用保驾护航"
        titleColor="#081745"
      />
      <div class="box6-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          ref="item"
          :id="'subject-box-item' + index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div class="title">
              <p>{{ item.stage }}</p>
              {{ item.title }}
              <img
                class="add"
                v-if="index == 2"
                src="../../../assets/coursePage/ai2/box6/add.svg"
              />
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <Stage1 v-if="index == 0"></Stage1>
            <Stage2 v-if="index == 1" @openVan="openVan"></Stage2>
            <Stage3 v-if="index == 2"></Stage3>
            <Stage4 v-if="index == 3" @openVan="openVan"></Stage4>
          </div>
        </div>
      </div>
      <div class="more" @click="zixun('了解更多')">了解更多</div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="van-block">
        <div class="block-tops">
          <div class="title">{{ currentData.name }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="content">
          <div
            class="contentItem"
            v-for="(item, index) in currentData.content"
            :key="index"
          >
            <div class="contentTitle">
              <img
                :src="
                  require(`../../../assets/coursePage/ai2/box6/${item.img}.svg`)
                "
              />
              <h1>{{ item.title }}</h1>
            </div>
            <div class="contentTxt">
              <p v-for="(itemP, indexP) in item.p" :key="indexP">
                <i v-if="item.p.length > 1"></i>
                {{ itemP }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
import Stage1 from "./components/Stage1.vue";
import Stage2 from "./components/Stage2.vue";
import Stage3 from "./components/Stage3.vue";
import Stage4 from "./components/Stage4.vue";
export default {
  components: {
    pageTitle,
    Stage1,
    Stage2,
    Stage3,
    Stage4,
  },
  mounted() {},
  data() {
    return {
      show: false,
      currentData: {},
      data: [
        {
          name: "金融行业动态风向评估",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: ["提问效率低、准确性差、可解释性弱、跨领域应用效果差、成本高"],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: [
                "基于Zero-shot零样本学习能力，对金融领域数据进行分类、信息抽取、文本匹配",
              ],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["金融领域"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握基于Zero-shot方式实现LLM应用的过程",
                "掌握基于Zero-shot方式实现ChatGLM模型进行文本分类",
                "掌握基于Zero-shot方式实现ChatGLM模型进行信息抽取",
                "掌握基于Zero-shot方式实现ChatGLM模型进行文本匹配",
              ],
            },
          ],
        },
        {
          name: "物流行业信息咨询智能问答系统",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: ["大模型“幻觉”问题（答案不精准）"],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: ["基于本地已有的知识信息让大模型根据本地信息进行准确回答"],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["物流领域"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握LangChain工具的基本使用方式",
                "理解向量知识库以及实现知识库的技术原理",
                "掌握LangChain+ChatGLM-6B实现基于本地知识库问答的机器人搭建方法",
              ],
            },
          ],
        },
        {
          name: "社交领域虚拟试衣系统",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: ["图像真实性差，面料质感无法呈现，颜色还原度低，尺码不匹配"],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: ["用户不用亲自试穿衣服，就可以实现换装查看效果的一种技术应用"],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["电商领域"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握基于Virtual-Tryoon单阶段端到端的虚拟试衣框架",
                "掌握虚拟试衣任务数据集的构建方式和模型训练方法",
                "了解虚拟试衣等变换任务的评估方法",
              ],
            },
          ],
        },
        {
          name: "大健康行业智能问诊系统",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: [
                "患者流量大、医生资源有限、医疗信息不对称、地域限制、隐私保护、诊疗准确性、系统稳定性和数据安全性等",
              ],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: [
                "解决医疗领域知识问答问题",
                "解决智能对话系统准确回答用户常见问题的需求，为用户解决健康、养老、医疗等疑问",
                "解决智能对话系统提供个性化推荐、日程安排等服务的需求，提升用户体验",
              ],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["医疗领域"],
            },
            {
              img: "icon-area",
              title: "拓展领域",
              p: ["客服机器人、医疗机器人、金融理财问答机器人"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握基于预训练模型实现聊天机器人搭建的原理及过程",
                "实现从0到1搭建类似ChatGPT的聊天机器人",
              ],
            },
          ],
        },
        {
          name: "新零售行业评价决策系统",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: [
                "由于某些领域特殊性、标注成本高，导致标注训练数据缺乏，模型无法有效学习参数，从而出现拟合现象",
              ],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: [
                "基于BERT+PET（硬模版）/P-Tuning(更智能)方法实现评论文本的准确分类，以优化产品性能和服务",
              ],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["新零售行业"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握基于预训练模型+PET微调方式的小样本分类方法",
                "掌握基于预训练模型+P-Tuning微调方式的小样本分类方法",
                "理解Prompt-Tuning微调方法带来的优势",
              ],
            },
          ],
        },
        {
          name: "新媒体行业评论智能分类与信息抽取系统",
          content: [
            {
              img: "icon-painspot",
              title: "业务痛点",
              p: ["基于一个大模型，解决多业务场景的问题"],
            },
            {
              img: "icon-demand",
              title: "项目需求",
              p: ["通过训练大模型同时解决多种任务开发和应用"],
            },
            {
              img: "icon-sence",
              title: "业务场景",
              p: ["新媒体领域"],
            },
            {
              img: "icon-result",
              title: "项目收获",
              p: [
                "掌握基于ChatGLM-6B大模型进行Lora微调的方式",
                "掌握基于ChatGLM-6B大模型进行P-Tuning微调的方式",
                "掌握基于LLM进行混合任务开发应用的实现过程",
                "掌握基于Flask框架实现API接口开发和应用",
              ],
            },
          ],
        },
      ],
      subject: [
        {
          stage: "阶段一",
          title: "大模型入门",
        },
        {
          stage: "阶段二",
          title: "大模型应用初体验",
        },
        {
          stage: "阶段三",
          title: "大模型初级开发",
        },
        {
          stage: "阶段四",
          title: "大模型高级开发",
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  created() {
    this.currentData = this.data[0];
  },
  methods: {
    zixun(name) {
      this.mai("AI大模型训练营", "了解更多", 0, null);
      this.clickZiXun()
    },
    openVan(number) {
      this.show = true;
      this.currentData = this.data[number];
    },
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
      this.mai("AI大模型训练营", "查看详细大纲", 0, null);
    },
    goTop(index) {
      console.log(index, "index");
      // window.scrollTo(
      //   0,
      //   this.$refs.item[index].offsetTop -

      //     this.prevItemHeight+60
      // );
      this.$nextTick(() => {
        document.getElementById("box6-btm-box").scrollIntoView({
          behavior: "smooth", // 平滑滚动到位置
        });
      });
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding-top: 80px;
  background: #e2f3ff;
  .more {
    height: 96px;
    background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
    box-shadow: 0px 4px 8px 0px #eaf6fc;
    border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
    font-style: normal;
    margin: 60px 32px 0;
  }
  .box6-btm-box {
    padding-bottom: 60px;
    width: 100%;

    .box6-btm {
      margin-top: 48px;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .subject-box:last-child {
    margin-bottom: 0;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #4e5969;
      line-height: 40px;
      position: relative;
      .add {
        position: absolute;
        left: 310px;
        top: 50%;
        transform: translateY(-50%);
        width: 94px;
        height: 36px;
      }
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: #4080ff;
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;
    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      background: #f2f3f5;
      margin-left: -8px;
    }
  }

  .show-answer {
    padding: 0px 40px 32px;
    border-radius: 16px;
    // display: block;
    max-height: 2696px;
    opacity: 1;
    transition: 0.4s ease all;
  }
}
.van-block {
  position: relative;
  // height: 1120px;
  padding: 0px 48px 60px;
  padding-top: 0px;
  background: #ffffff;
  border-radius: 20px;
  box-sizing: border-box;
  .block-tops {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    align-items: center;
    height: 132px;
    padding-top: 16px;
    .title {
      font-size: 34px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #1d2129;
      line-height: 52px;
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
  }
  .content {
    .contentItem {
      margin-bottom: 20px;
      .contentTitle {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        img {
          width: 32px;
          margin-right: 6px;
        }
        h1 {
          font-size: 26px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #001751;
          line-height: 44px;
        }
      }
      .contentTxt {
        p {
          font-size: 26px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
          display: flex;
          align-items: flex-start;
          text-align: left;
          margin-bottom: 8px;
          i {
            display: block;
            width: 8px;
            height: 8px;
            background: #ff8644;
            border-radius: 4px;
            margin-right: 12px;
            margin-top: 16px;
          }
        }
      }
    }
  }
}
</style>
